import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import useAuth from '../../auth/useAuth';
import cognitoConfig from '../../auth/cognitoConfig';

export default function CallbackPage() {
  const [searchParams] = useSearchParams();
  const { saveTokens } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const code = searchParams.get('code');
    if (!code) {
      setError('No authorization code received');
      return;
    }

    const exchangeCode = async () => {
      try {
        const apiBase = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';
        const res = await fetch(`${apiBase}/api/auth/token`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            code,
            redirect_uri: cognitoConfig.redirectUri,
          }),
        });

        const data = await res.json();

        if (!res.ok || !data.success) {
          throw new Error(data.error || 'Token exchange failed');
        }

        saveTokens(data.data);
        navigate('/dashboard', { replace: true });
      } catch (err) {
        console.error('Callback error:', err);
        setError(err.message || 'Authentication failed. Please try again.');
      }
    };

    exchangeCode();
  }, [searchParams, saveTokens, navigate]);

  if (error) {
    return (
      <div className="mol-login">
        <div className="mol-login__card">
          <h2 className="mol-login__title">Authentication Error</h2>
          <p className="mol-login__subtitle">{error}</p>
          <button className="mol-btn mol-btn--primary" onClick={() => navigate('/login')}>
            Return to Login
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="mol-login">
      <div className="mol-login__card">
        <div className="mol-loading-spinner" />
        <p style={{ marginTop: '16px', color: '#6B7280' }}>Completing sign-in...</p>
      </div>
    </div>
  );
}
